module.exports = __webpack_public_path__ + "static/img/007.727173d2.jpg";